// extracted by mini-css-extract-plugin
export var view = "BZeWz";